import { Directive } from "@angular/core";
import { CesiumPointerManagerService } from "./cesium-pointer-manager.service";
import { ThrottledCesiumEventBuilder } from "./throttled-cesium-event-builder";

// TODO: DTM-6092 - remove when all components are migrated away from ngx-cesium
@Directive({
    selector: "[dtmMapPointerManager]",
    providers: [
        CesiumPointerManagerService,
        ThrottledCesiumEventBuilder,
        {
            provide: ThrottledCesiumEventBuilder,
            useExisting: ThrottledCesiumEventBuilder,
        },
    ],
})
export class CesiumPointerManagerDirective {
    constructor() {
        throw new Error("CesiumPointerManagerDirective is deprecated and will be removed in future releases.");
    }
}
